import { createAppRequest } from '@/services/request';
import type { AssetOverviewResponse } from './types/asset-overview';

const request = createAppRequest();
const BASE = '/bff/api/asset';

export async function getAssetOverview(): Promise<AssetOverviewResponse> {
  return request<AssetOverviewResponse>(`${BASE}/overview`, { method: 'GET' });
}
